import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class ScrollDirection {
    constructor() {
        const header = document.querySelector('.js-header');
        if (header) {
            this.init();
        }
    }

    init() {
        const header = document.querySelector('.js-header'); /*,
      headerElements = header.querySelectorAll(':scope > *');*/

        let lastScrollY = window.scrollY,
            isHeaderVisible = true;
        const scrollThreshold = 0;

        ScrollTrigger.create({
            start: 100,
            end: 'max',
            onUpdate: (self) => {
                const currentScrollY = self.scroll();
                const header = document.querySelector('.js-header');

                if (!header) return;

                if (currentScrollY > lastScrollY + scrollThreshold && isHeaderVisible) {
                    isHeaderVisible = false;
                    header.classList.add('scrolling-down');
                    // console.log("header scrolled");
                } else if (currentScrollY < lastScrollY && !isHeaderVisible) {
                    isHeaderVisible = true;
                    header.classList.remove('scrolling-down');
                }

                lastScrollY = currentScrollY;
            }
        });
    }
}

export default ScrollDirection;
